import { Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Users } from "lucide-react";
import { useMe } from "@/components/auth/RequireAuth";

export const TopBar = ({ children }) => {
  const me = useMe();
  return (
    <header className="sticky top-0 z-40 bg-[#0A0A0A] border-b border-white/15">
      <div className="max-w-7xl mx-auto px-3 sm:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-home" className="flex items-center gap-3 shrink-0">
          <span className="w-8 h-8 shrink-0 bg-[#CCFF00] text-black font-display font-extrabold text-lg flex items-center justify-center">A</span>
          <span className={`font-display text-xl font-bold uppercase tracking-wide ${children ? "hidden sm:inline" : ""}`}>Apito<span className="text-[#CCFF00]">.</span>Registo</span>
        </Link>
        <div className="flex items-center gap-2">
          {children}
          {!children && me?.role === "admin" && (
            <Link to="/utilizadores" data-testid="nav-users" className="tap h-10 px-3 border border-white/15 flex items-center gap-2 text-sm hover:bg-white/5">
              <Users size={16} /> <span className="hidden sm:inline">Utilizadores</span>
            </Link>
          )}
          <div data-testid="user-menu" className="ml-1 flex items-center"><UserButton /></div>
        </div>
      </div>
    </header>
  );
};
